import { useState, useEffect } from 'react'

// One-shot fetch of the atlas stock universe + derive sectors list.
// Sector labels are now fully canonical V2 names in the DB (post the
// discover_sector_taxonomy_v2 + rename_sectors_label_v2 migrations), so
// no client-side aliasing is needed — the API returns the display string
// directly.
export function useAtlasStocks({ includeInactive = false } = {}) {
  const [stocks, setStocks] = useState([])
  const [sectors, setSectors] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    const url = includeInactive
      ? '/api/atlas-data?resource=stocks&includeInactive=1'
      : '/api/atlas-data?resource=stocks'
    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`atlas-data ${r.status}`)
        return r.json()
      })
      .then((data) => {
        if (cancelled) return
        const list = data.stocks ?? []
        // Default: drop active=false (legacy hidden universe + hunting tier).
        // includeInactive=true keeps them — needed by the Market Map / desks
        // since 109 of 110 hunting-tier rows carry active=false.
        const seen = new Set()
        const active = list.filter((s) => {
          if (!includeInactive && s.active === false) return false
          if (seen.has(s.ticker)) return false
          seen.add(s.ticker)
          return true
        })
        const sectorSet = [...new Set(active.map((s) => s.sector).filter(Boolean))].sort()
        setStocks(active)
        setSectors(sectorSet)
        setLoading(false)
      })
      .catch((err) => {
        if (cancelled) return
        setError(err.message)
        setLoading(false)
      })
    return () => { cancelled = true }
  }, [includeInactive])

  return { stocks, sectors, loading, error }
}
